import popupStyles from "./companyExistPopup.module.css";

import doctor from "../../../images/questionnaire_doctor.png";

import { IPopupWithoutProps } from "../../../types/types";

import { tWithKeyAttr as t } from "../../../i18nHelper";

import { useNavigate } from "react-router-dom";

import { ROUTES } from "../../../utils/routes";

function CompanyExistPopup() {

    const navigate = useNavigate();

    const onApproval = () => {
        navigate(ROUTES.LOGIN);
    };

    return (

        <article className={popupStyles.popup} data-testid="company-exist-popup">

            <h2 className={popupStyles.popup__title}>{t('COMPANY_EXIST')}</h2>

            <p className={popupStyles.popup__text}>

                {t('COMPANY_EXIST_TEXT')}

            </p>

            <img

                src={doctor}

                alt="Doctor"

                className={popupStyles.popup__img}

            />

            <button

                type="button"

                data-testid= {"go-to-login"}

                className={`${popupStyles.popup__nextBtn} hover`}

                onClick={onApproval}

            >

                { t('CONFIRM')}

            </button>

        </article>

    );

}

export default CompanyExistPopup;

